import React from 'react';

const NoRoute = () => {
    return (
        <div>
            <h1>No Route Found</h1>
        </div>
    );
};

export default NoRoute;